var map = {
  "./cs.json": [
    "lqb",
    [
      "vh"
    ]
  ],
  "./en.json": [
    "ng",
    [
      "1p"
    ]
  ],
  "./pl.json": [
    "eJW",
    [
      82
    ]
  ],
  "./ru.json": [
    "ZaO",
    [
      "re"
    ]
  ],
  "./tr.json": [
    "Dq",
    [
      938
    ]
  ],
  "./ja.json": [
    "bnM",
    [
      "tu"
    ]
  ],
  "./zh.json": [
    "XH",
    [
      "5o"
    ]
  ],
  "./pt-br.json": [
    "xB",
    [
      "f18"
    ]
  ],
  "./de.json": [
    "P6S",
    [
      "hke"
    ]
  ],
  "./es.json": [
    "CU",
    [
      "sy"
    ]
  ],
  "./fr.json": [
    "Epr",
    [
      "i0c"
    ]
  ],
  "./it.json": [
    "Wnb",
    [
      "wf"
    ]
  ],
  "./ko.json": [
    "kV",
    [
      "m2"
    ]
  ],
  "./pt.json": [
    "xUn",
    [
      "rj5"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "tj";
module.exports = __rspack_async_context;
